module.exports = __webpack_public_path__ + "assets/img/Type E (71).862ab5f2.jpg";